import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-api-view',
  templateUrl: './api-view.component.html',
  styleUrls: ['./api-view.component.scss'],
})
export class ApiViewComponent implements OnInit {
  viewData: any;
  openList: any;

  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, public user: User, private route: ActivatedRoute, private router: Router) {
    this.api.getAccessKeyById(this.route.snapshot.paramMap.get('id')).subscribe((data: any) => {
      this.viewData = data;
      this.openList = this.viewData.openAPISettings;
      this.openList.forEach((notification) => {
        notification.apiSettingsResponses.forEach((n) => {
          if (n.notify === 'ON') {
            n.enabled = true;
          } else {
            n.enabled = false;
          }
        });
      });

    }, err => {
      this.alertService.error('Error', err);
    });
  }

  editApiDetails() {
    this.router.navigate(['/admin/apiEdit/' + this.viewData.id]);
  }

  sliceUPto(num) {
    if (num) {
      if (num % 2 == 0) {
        return num / 2;
      } else {
        return (num + 1) / 2;
      }
    } else {
      return 0;
    }
  }

  ngOnInit() { }

}
